// extracted by mini-css-extract-plugin
export default {"content":"NewsContent_content__DlUXN","header":"NewsContent_header__oA5I3","cards":"NewsContent_cards__VGxAX","card":"NewsContent_card__EKmZl"};